import type { FC } from 'react';
import { Flex } from '@chakra-ui/react';
import { Text } from '../../../ui-components';

export interface PlpBadgeProps {
    text: string;
    backgroundColor?: string;
    textColor?: string;
}

export const PlpBadge: FC<PlpBadgeProps> = ({
    text,
    backgroundColor = 'slt-pepper.800',
    textColor = 'white',
}) => (
    <Flex
        borderRadius="4px"
        backgroundColor={backgroundColor}
        paddingX="8px"
        paddingY="2px"
        alignItems="center"
    >
        <Text style="bold" size="xs" color={textColor} textTransform="uppercase">
            {text}
        </Text>
    </Flex>
);

PlpBadge.defaultProps = {
    backgroundColor: 'slt-pepper.800',
    textColor: 'white',
};
